import { useQuery } from '@tanstack/react-query'
import { useClient } from '@/stores/useClient.ts'
import { ProfContact } from '@/models/profContact.ts'

export const PROF_CONTACTS_QUERY_KEY = ['prof-contacts']

/** Shared query for the account's "Marken" (no pagination, sorted by name). */
export function useProfContacts() {
  const { getContacts } = useClient()
  return useQuery({
    queryKey: PROF_CONTACTS_QUERY_KEY,
    queryFn: async () => {
      const res = await getContacts()
      return res.data as ProfContact[]
    },
  })
}

interface ProfContactSelectProps {
  /** `null` = account default contact */
  value: string | null
  onChange: (contactId: string | null) => void
  disabled?: boolean
  className?: string
}

/**
 * "Marke / Kontakt" picker for projects and project templates. There is deliberately no
 * "not part of the template" option: `null` always means "Standardkontakt".
 */
export default function ProfContactSelect({
  value,
  onChange,
  disabled,
  className = 'select select-bordered w-full',
}: ProfContactSelectProps) {
  const { data: contacts } = useProfContacts()

  return (
    <select
      className={className}
      value={value ?? ''}
      onChange={e => onChange(e.target.value || null)}
      disabled={disabled}
    >
      <option value="">Standardkontakt</option>
      {contacts?.map(contact => (
        <option key={contact.id} value={contact.id}>{contact.name}</option>
      ))}
    </select>
  )
}
